export const typesCoursesb2b = {
    getCoursesb2b: '[courses] get_courses_b2b',
    createCoursesb2b: '[courses] create_courses_b2b',
    updateCoursesb2b: '[courses] update_courses_b2b',
    deleteCoursesb2b: '[courses] delete_courses_b2b',
}
